import { createApp, App } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createPinia } from 'pinia'
import { createApplication } from '@/app'

import 'vue-slider-component/theme/default.css'
import 'vue-final-modal/style.css'
import "flag-icons/css/flag-icons.min.css"
import "vue3-colorpicker/style.css"
import './styles/index.sass'

import './utils/index'


export const app = createApplication({
  createApp, createRouter, createWebHistory, createPinia,
})

window.app = app

declare global {
  interface Window {
    IS_AUTH: number | false
    IS_SUPER: number | false
    ACCESS_TOKENS: string[]
    ALL_ACCESS_TOKENS: Record<string, any>
    // USER_PERMISSIONS: any
    // ALL_PERMISSIONS: any
    google: {
      maps: any
    }
    current_city: {
      title: string,
      location: {
        lng: number,
        lat: number,
      }
    },
    initMap: () => void
    language: string
    languages: Record<string, string>[]
    languages_changer: string
    site_title: string
    show_site_title: boolean
    default_language: string
    current_language: string
    country_code: string

    django: {
      catalog: {
        [key: string]: string
      }
    }
    app: App
    captcha_key: string
    GOOGLE_MAPS_KEY: string
    login_url: string
    reset_password_url: string
    registration_url: string
    comparisons_url: string
    favicon_url: string
    favorites_url: string
    comparison_url: string
    user_agreement: string
    owner_catalog_url: string
    privacy_policy: string
    rules_url: string
    maps_key: string
    logo_header_url: string
    logo_sidebar_url: string
    cabinet_url: string
    default_avatar: string
    // carfax_link: string
    show_calculator: boolean
    has_access_to_clients: boolean
    dealers_site: string
    user_uuid: string
    addit_color: string
    sidebar_color: string
  }
}


